$(document).ready(function(){
	
	$('ul.cstm-tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.cstm-tabs li').removeClass('current');
		$('.cstm-tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	});

});

  $(document).ready(function() {
  
    $(".btn-globo").click(function(e) {
      e.preventDefault();
      alert( "test" );
    });
    
});